import React, { useEffect, useState } from "react";
import { AlertComponent } from "src/components/AlertComponent";
import Heading from "./Heading";
import { useSearchParams } from "react-router-dom";
import { loadingState } from "src/atom/LoadingState";
import { useRecoilState } from "recoil";
import callApi from "src/services/Common/api";
import Loader from "src/components/loader/Loader";

const ViewAdmitCard = () => {
  const [searchParams] = useSearchParams();
  const encryptedData = searchParams.get("encryptedData");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertvisible, setAlertVisible] = useState(false);
  const [loader, enableLoader] = useRecoilState(loadingState);
  const [pdfUrl, setPdfUrl] = useState("");

  const handleCloseAlert = () => {
    setAlertVisible(false);
    setAlertMessage("");
  };

  useEffect(() => {
    if (encryptedData) {
      handleDataChange();
    }
  }, []);

  const handleDataChange = async () => {
    enableLoader(true);
    const response = await callApi(
      `/v1/api/admit-cards/original-admit-card/${encryptedData}`,
      "GET",
      null,
      true,
      setAlertMessage,
      false
    );
    enableLoader(false);
    if (response.success) {
      if (response?.body) {
        const dataUrl = `data:application/pdf;base64,${response.body}`;
        setPdfUrl(dataUrl);
      }
    }
  };

  return (
    <>
      <AlertComponent
        message={alertMessage}
        visible={alertvisible}
        onClose={handleCloseAlert}
      />
      {loader ? <Loader /> : <></>}
      <Heading />
      <div className="card ms-1 me-1">
        <div className="card-body">
          {pdfUrl ? (
            <div style={{ height: "80vh" }}>
              <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{ border: "none" }}
              />
            </div>
          ) : (
            <div className="text-center">
              {loader ? "Loading Admit Card..." : "No Admit Card Available"}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewAdmitCard;
